import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MainLayout = () => {
  return (
    <div className="main-layout">
      {/* Navigation Bar */}
      <Navbar />

      {/* Main Content - Routes go here */}
      <main className="main-content">
        <Outlet />
      </main>

      {/* Footer with Three.js Particles */}
      <Footer />
    </div>
  );
};

export default MainLayout;